// removed by extract-text-webpack-plugin
module.exports = {"root":"address-grid--root--n2bxCFQM","add-address":"address-grid--add-address--2QzRMMcT","addAddress":"address-grid--add-address--2QzRMMcT","button-text":"address-grid--button-text--2Wpn4en7","buttonText":"address-grid--button-text--2Wpn4en7","button-container":"address-grid--button-container--1RCj6DUs","buttonContainer":"address-grid--button-container--1RCj6DUs"};


//////////////////
// WEBPACK FOOTER
// ./components/address-grid/styles.css
// module id = ./components/address-grid/styles.css
// module chunks = 0